import React, { useState, useEffect } from 'react'
import { Card, Row, Col, Modal, Upload } from 'antd'
import { ButtonComponent as Button } from '../../components'
import moment from 'moment'
import { ReactComponent as iconUpload } from '../../assets/img/upload.svg'
import { LoadingOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons';
import DenyWithdrawl from './denyWithdrawl'
import AddQuota from './addQuota'
import { ReactComponent as iconError } from '../../assets/img/error.svg'
import { ReactComponent as iconCheck } from '../../assets/img/check.svg'
import { maskCpf, maskCurrency, getContractTypeName, getDisplayContractName } from '../../utils/functions';

const { Dragger } = Upload

// Adaptador para transformar o formato de dados da API
const adaptWithdrawlData = (withdrawl) => {
    if (!withdrawl) return null;
    
    // Cria uma cópia do objeto para não modificar o original
    const adapted = { ...withdrawl };
    
    // Verifica se o contrato existe em formato básico (só ID)
    if (!adapted.Contrato && (adapted.contrato || adapted.idContrato)) {
        // Cria objeto Contrato padronizado
        adapted.Contrato = {
            id: adapted.contrato?.id || adapted.idContrato,
            tipoContrato: (adapted.contrato?.tipoContrato != null ? adapted.contrato.tipoContrato : (adapted.tipo === 'spirit' ? 6 : adapted.tipo === 'asa' ? 1 : undefined)),
            tipoContratoNome: adapted.contrato?.tipoContratoNome,
            // Adicionar campos bancários do paymentInfo se disponíveis
            codigoBanco: adapted.paymentInfo?.codigoBanco,
            nomeBanco: adapted.paymentInfo?.nomeBanco,
            numeroAgencia: adapted.paymentInfo?.numeroAgencia,
            numeroConta: adapted.paymentInfo?.numeroConta,
            tipoConta: adapted.paymentInfo?.tipoConta
        };
    }
    
    // Garantir que tipoContrato e tipoContratoNome estejam preenchidos a partir de `contrato` quando disponíveis
    if (adapted.Contrato) {
        if (adapted.Contrato.tipoContrato == null && adapted.contrato?.tipoContrato != null) {
            adapted.Contrato.tipoContrato = adapted.contrato.tipoContrato;
        }
        if (!adapted.Contrato.tipoContratoNome && adapted.contrato?.tipoContratoNome) {
            adapted.Contrato.tipoContratoNome = adapted.contrato.tipoContratoNome;
        }
    }
    
    // Se o Contrato não tem Cliente mas temos informações do usuário
    if (adapted.Contrato && !adapted.Contrato.Cliente && adapted.usuario) {
        adapted.Contrato.Cliente = {
            id: adapted.usuario.id,
            nome: adapted.usuario.nome,
            cpf: adapted.usuario.cpf,
            email: adapted.usuario.email
        };
    }
    
    return adapted;
};

const CardWithdrawls = (props) => {
    const [openModal, setOpenModal] = useState(false)
    const [openModalQuota, setOpenModalQuota] = useState(false)
    const [showUpload, setShowUpload] = useState(false)
    const [showId, setShowId] = useState(0)
    const [file, setFile] = useState(null)
    const { status, withdrawl: originalWithdrawl, isSubmit, success, deny, clicked, approved, approve, quote, onTransfer } = props
    
    // Adaptar os dados do resgate
    const [withdrawl, setWithdrawl] = useState(null);
    
    useEffect(() => {
        if (originalWithdrawl) {
            setWithdrawl(adaptWithdrawlData(originalWithdrawl));
        }
    }, [originalWithdrawl]);
    
    const classes = {
        pending: 'card-pending',
        transfer: 'card-transfer',
        quota: 'card-quota'
    }

    const returnStatus = {
        pending: 'aprovado',
        quota: 'cotizado',
        transfer: 'transferido'
    }
    
    // Verificar se existe um objeto de resgate
    if (!withdrawl) {
        return (
            <Card className={`${classes[status] || 'card-pending'} card-warning`}>
                <div className="d-flex align-center justify-center flex-column">
                    <Icon component={iconError} />
                    <h1 className="tx-white font-bold mt-15 font-16 text-center">Carregando dados...</h1>
                    <p className="tx-white text-center">Aguarde enquanto processamos os dados do resgate.</p>
                </div>
            </Card>
        );
    }
    
    // Se não tiver Contrato ou contrato, tenta usar campos da resposta da API
    const userInfo = withdrawl.usuario || {};
    const contractInfo = withdrawl.contrato || {};
    const contractId = withdrawl.Contrato?.id || contractInfo?.id || withdrawl.idContrato || 'N/A';
    
    // Verifica se o objeto Contrato existe, se não, cria um objeto vazio para evitar erros
    const contratoSafe = withdrawl.Contrato || {};
    
    // Verificar se o contrato contém informações do cliente
    const hasValidContractAndClient = contratoSafe.Cliente != null;
    
    // Se o contrato não tem cliente, use informações do campo usuario se disponível
    const clienteNome = hasValidContractAndClient ? contratoSafe.Cliente.nome : (userInfo.nome || 'Nome indisponível');
    const clienteCpf = hasValidContractAndClient ? (contratoSafe.Cliente.cpf || '') : (userInfo.cpf || '');
    
    // Se o contrato não tem tipo definido, tente determinar a partir de outros campos
    const nomeTipoContrato = contratoSafe.tipoContratoNome || contractInfo?.tipoContratoNome;
    const tipoLabel = getDisplayContractName(nomeTipoContrato, contratoSafe.tipoContrato);
    
    const handleModal = () => {
        const aux = openModal
        setOpenModal(!aux)
    }

    const handleModalQuota = () => {
        const aux = openModalQuota
        setOpenModalQuota(!aux)
    }

    const handleShowUpload = (idWithdrawl) => {
        setShowId(idWithdrawl)
        setShowUpload(true)
    }

    const beforeUpload = file => {
        setFile(file)
        return false
    }
    
    // Se ainda estamos com dados incompletos após a adaptação, mostrar botão para tentar processar mesmo assim
    if (!withdrawl.Contrato || !withdrawl.Contrato.Cliente) {
        return (
            <Card className={`${classes[status] || 'card-pending'} card-warning`}>
                <div className="d-flex align-center justify-center flex-column">
                    <Icon component={iconError} />
                    <h1 className="tx-white font-bold mt-15 font-16 text-center">Resgate com dados incompletos</h1>
                    <p className="tx-white mt-10 text-center">ID: {withdrawl.id || 'N/A'}</p>
                    <p className="tx-white text-center">Este resgate possui dados incompletos.</p>
                    {userInfo.nome && <p className="tx-white text-center">Cliente: {userInfo.nome}</p>}
                    {contractId !== 'N/A' && <p className="tx-white text-center">Contrato ID: {contractId}</p>}
                    
                    {status === 'pending' && (
                        <Row className="mt-15 px-20" style={{ width: '100%' }}>
                            <Col md={12} className="pr-5">
                                <Button type="danger" onClick={handleModal} disabled={isSubmit && clicked === withdrawl.id}>
                                    {isSubmit && !approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Reprovar"}
                                </Button>
                            </Col>
                            <Col md={12} className="pl-5">
                                <Button type="success" disabled={isSubmit && clicked === withdrawl.id} 
                                    onClick={() => approve(withdrawl.id, contractId, true)}>
                                    {isSubmit && approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Aprovar"}
                                </Button>
                            </Col>
                        </Row>
                    )}
                    
                    {status === 'quota' && (
                        <Row className="mt-15 px-20" style={{ width: '100%' }}>
                            <Col md={24}>
                                <Button type="primary" active disabled={isSubmit && clicked === withdrawl.id} onClick={handleModalQuota}>
                                    {isSubmit && approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Inserir Cotação"}
                                </Button>
                            </Col>
                        </Row>
                    )}
                    
                    {status === 'transfer' && (
                        <Row className="mt-15 px-20" style={{ width: '100%' }}>
                            <Col md={24}>
                                <Button icon={iconUpload} type="primary" onClick={() => handleShowUpload(withdrawl.id)}>
                                    Upload Comprovante
                                </Button>
                            </Col>
                            {showUpload && showId === withdrawl.id && (
                                <Col md={24} className="mt-10">
                                    <Dragger height={100} beforeUpload={beforeUpload} onRemove={() => setFile(null)}>
                                        <div className="d-flex justify-center align-center">
                                            <Icon component={iconUpload} className="font-22" />
                                            <label className="tx-gray font-bold ml-5">Clique ou arraste o arquivo aqui</label>
                                        </div>
                                    </Dragger>
                                    <Button type="primary" className="mt-10" onClick={() => onTransfer(contractId, withdrawl.id, file)}>
                                        {isSubmit && approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Enviar Comprovante"}
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </Card>
        );
    }

    return (
        <>
        <Card className={`${classes[status] || 'card-pending'} ${success && clicked === withdrawl.id && !isSubmit ? approved ? 'card-success' : 'card-reproved' : ''}`} style={{height: showId === withdrawl.id && 'auto'}}>
            {success && clicked === withdrawl.id && !isSubmit ? approved ?
                <div className="d-flex align-center justify-center flex-column">
                    <Icon component={iconCheck} />
                    <h1 className="tx-white font-bold mt-15 font-22 text-center">Resgate {returnStatus[status] || ''}</h1>
                </div> :
                <div className="d-flex align-center justify-center flex-column">
                    <Icon component={iconError} />
                    <h1 className="tx-white font-bold mt-15 font-22 text-center">Resgate reprovado</h1>
                </div> :
            <>
            <Row>
                <Col md={12}>
                    <h4 className="tx-pink card-title font-16">{clienteNome}</h4>
                </Col>
                <Col md={4}></Col>
                <Col md={8}>
                    <h4 className="tx-pink card-title">{tipoLabel}</h4>
                    <label className="tx-gray">#{contractId}</label>
                </Col>
            </Row>
            <hr />
            {status === 'pending' && 
                <Row>
                    <Col md={12}>
                        <label className="tx-pink font-bold">Solicitação</label><br />
                        <label className="tx-gray">{withdrawl.dataSolicitacao ? moment(withdrawl.dataSolicitacao).format('DD/MM/YYYY') : 'N/A'}</label>
                    </Col>
                </Row>
            }
            {status === 'quota' &&
                <Row>
                    <Col md={12}>
                        <label className="tx-pink font-bold">Aprovação</label><br />
                        <label className="tx-gray">{withdrawl.dataAprovacao ? moment(withdrawl.dataAprovacao).format('DD/MM/YYYY') : 'N/A'}</label>
                    </Col>
                    <Col md={12}>
                        <label className="tx-pink font-bold">Limite cotização</label><br />
                        <label className="tx-gray">{withdrawl.dataCotizacao ? moment(withdrawl.dataCotizacao).format('DD/MM/YYYY') : 'N/A'}</label>
                    </Col>
                </Row>
            }
            {status === 'transfer' &&
                <Row>
                    <Col md={12}>
                        <label className="tx-pink font-bold">Cotização</label><br />
                        <label className="tx-gray">{withdrawl.dataCotizacao ? moment(withdrawl.dataCotizacao).format('DD/MM/YYYY') : 'N/A'}</label>
                    </Col>
                    <Col md={12}>
                        <label className="tx-pink font-bold">Limite transferência</label><br />
                        <label className="tx-gray">{withdrawl.dataTransferencia ? moment(withdrawl.dataTransferencia).format('DD/MM/YYYY') : 'N/A'}</label>
                    </Col>
                </Row>
            }
            <hr />
            <Row>
                <Col md={24}>
                    <label className="tx-pink font-bold">Valor</label><br />
                    <label className="tx-gray font-22 font-bold">R${maskCurrency(withdrawl.valor || 0)}</label>
                </Col>
            </Row>
            {status === 'transfer' &&
                <>
                    <hr />
                    <Row>
                        <Col md={24}>
                            <label className="tx-pink font-bold font-16">Dados Bancários</label><br />
                            <label className="tx-gray mt-10">{clienteNome}</label>
                        </Col>
                        <Col md={24} className="mt-15">
                            <label className="tx-pink font-bold">CPF</label><br />
                            <label className="tx-gray">{maskCpf(clienteCpf)}</label>
                        </Col>
                        <Col md={24} className="mt-15">
                            <label className="tx-pink font-bold">Banco</label><br />
                            <label className="tx-gray">
                                {withdrawl.paymentInfo?.codigoBanco || contratoSafe.codigoBanco || 'N/A'} - 
                                {withdrawl.paymentInfo?.nomeBanco || contratoSafe.nomeBanco || 'N/A'}
                            </label>
                        </Col>
                        <Col md={12} className="mt-15">
                            <label className="tx-pink font-bold">Agência</label><br />
                            <label className="tx-gray">
                                {withdrawl.paymentInfo?.numeroAgencia || contratoSafe.numeroAgencia || 'N/A'}
                            </label>
                        </Col>
                        <Col md={12} className="mt-15">
                            <label className="tx-pink font-bold">Conta</label><br />
                            <label className="tx-gray">
                                {withdrawl.paymentInfo?.numeroConta || contratoSafe.numeroConta || 'N/A'}
                            </label>
                        </Col>
                        {showUpload && showId === withdrawl.id ? '' :
                        <Col md={24} className="mt-15">
                            <Button icon={iconUpload} type="primary" onClick={() => handleShowUpload(withdrawl.id)}>Upload Comprovante</Button>
                        </Col>}
                        {showUpload && showId === withdrawl.id ?
                        <Col md={24}>
                            <Dragger height={100} className="mt-10" beforeUpload={beforeUpload} onRemove={() => setFile(null)}>
                                <div className="d-flex justify-center align-center">
                                    <Icon component={iconUpload} className="font-22" />
                                    <label className="tx-gray font-bold ml-5">Clique ou arraste o arquivo aqui</label>
                                </div>
                            </Dragger>
                            <Button type="primary" onClick={() => onTransfer(contractId, withdrawl.id, file)}>
                                {isSubmit && approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Enviar Comprovante"}
                            </Button>
                        </Col> : ''}
                    </Row>
                </>
            }
            {status === 'pending' &&
                <Row className="mt-15">
                    <Col md={12} className="pr-5 mt-15">
                        <Button type="danger" onClick={handleModal} disabled={isSubmit && clicked === withdrawl.id ? true : false}>
                            {isSubmit && !approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Reprovar"}
                        </Button>
                    </Col>
                    <Col md={12} className="pl-5 mt-15">
                        <Button type="success" disabled={isSubmit && clicked === withdrawl.id ? true : false} 
                            onClick={() => approve(withdrawl.id, contractId, true)}>
                            {isSubmit && approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Aprovar"}
                        </Button>
                    </Col>
                </Row> } 
            {status === 'quota' &&
                <Row className="mt-15">
                    <Col md={24}>
                        <Button type="primary" disabled={isSubmit && clicked === withdrawl.id ? true : false} active onClick={handleModalQuota}>
                            {isSubmit && approved && clicked === withdrawl.id ? <LoadingOutlined /> : "Inserir Cotação"}
                        </Button>
                    </Col>
                </Row>
            }
            </>}
        </Card>
        <Modal
            visible={openModal}
            centered
            footer={null}
            closable={false}
            maskClosable={false}
            className="modal-deny"
            width="70vw"
        >
            <DenyWithdrawl withdrawl={withdrawl} handleModal={handleModal} deny={deny} />
        </Modal>
        <Modal
            visible={openModalQuota}
            centered
            footer={null}
            closable={false}
            maskClosable={false}
            className="modal-deny"
            width="70vw"
        >
            <AddQuota withdrawl={withdrawl} handleModal={handleModalQuota} quote={quote} />
        </Modal>
        </>
    )
}

export default CardWithdrawls